export const formContainerClasses = ['flex', 'flex-col', 'items-center justify-center', 'gap-6', 'px-8 pb-6 pt-0'];
export const buttonsContainerClasses = ['grid w-full grid-cols-2 justify-between gap-3'];
